import parse from 'html-react-parser';
import { createPortal } from 'react-dom';

function MetaFooter({ data }) {
  const meta = data || '';

  if (typeof document === 'undefined') return;

  // eslint-disable-next-line no-undef
  return createPortal(parse(meta), document?.querySelector?.('#meta-footer'));
}

export default MetaFooter;
